module.exports = __webpack_public_path__ + "static/media/SIT_logo.1e6d5dea.png";